<template>
  <div v-if="modelsList && modelsList.length" class="models_styles mb-4">
    <div v-for="(item, index) in modelsList" :key="index" class="">
      <div class="model_style_card h-100  text-center cursor_pointer  rounded_10  align-items-center"
        :style="[index === isChecked ? { border: '1px solid' + primaryColor } : { border: '0px solid #fff' }, { background: isGradient ? transparentColor : '#fff' }]"
        :class="[{ disabledContent: !isLastIndex }, { custom_box_shadow: !isGradient }]"
        @click.once="eachBodyStyle(item, index)">
        <div class="text-center" :style="[{ color: isGradient ? textColor : '#000' }]">
          <h4 class="_theme_font_bold text-black">{{ item.count }}
          </h4>
          <small>in stock</small>
        </div>
        <div class="text-center">
          <img :src="item.imageUrl" alt="" class="img-fluid" v-if="item.imageUrl" />
          <!-- <img src="../../../../../../images/no-image.png" alt="" class="img-fluid" v-else /> -->
          <div v-else>
            <NoVehicle />
          </div>
        </div>
        <div class="col-12">
          <p class="mb-3 _theme_font_bold" :style="[{ color: isGradient ? textColor : '#000' }]">{{ item.modelName }}
          </p>
          <!-- <small :style="[{ color: isGradient ? textColor : '#000' }]" class="mb-0" v-if="item.msrp">MSRP: ${{
            Thousandseperator(item.msrp) }}</small> -->
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';
import Thousandseperator from '../../../../../../js/filters/Thousandseperator';
import NoVehicle from './NoVehicle.vue';
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings'],
  data() {
    return {
      modelsList: [],
      primaryColor: window.primaryColor,
      isChecked: null,
      transparentColor: '',
      textColor: '#000'
    }
  },

  mounted() {

    if (this.botResponse?.component?.values?.length) {
      this.modelsList = this.botResponse?.component?.values;
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }

    if (this.isGradient) {
      this.primaryColor = '#fff';
      this.transparentColor = 'rgba(0, 0, 0, 0.1) !important';
      this.textColor = '#fff';
    }

    console.log(this.botResponse, 'ccc')

  },
  methods: {
    eachBodyStyle(item, index) {
      let specialObject = { TvmComponentRequest: item };
      ChatWidgetService.postTvmMessage(item.modelName, null, this.botResponse?.component?.submitFlow,
        this.botResponse?.component?.submitAction, specialObject);
      this.isChecked = index;
    },
    Thousandseperator(value) {
      return Thousandseperator(value);
    },
  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },
  components: {
    NoVehicle
  }

}
</script>
<style lang="less" scoped>
.models_styles {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.model_style_card {
  img {
    max-height: 120px;

  }

  h4 {
    font-size: 55px;
    opacity: 0.5;
    position: relative;
    top: 16px;
  }


  &.disabledContent {
    pointer-events: none !important;
    opacity: 0.9 !important;
  }

  .cursor_pointer {
    cursor: pointer;
  }

  small {
    font-size: 15px;
    display: block;
    min-height: 20px;
  }

}
</style>
